import React from 'react';
import { IFormErrorInput } from '../../common/interface/form';

export const FormError: React.FC<IFormErrorInput> = ({ errorMessage }) => <p style={{ color: 'red' }}>{errorMessage}</p>;
